import React,{useState} from 'react';
import {Button,Alert} from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import {authFetch} from '../utils/authFetch';

export default function InvoiceStornoButton({invoiceId,disabled=false}){
 const nav=useNavigate();const [busy,setBusy]=useState(false),[error,setError]=useState('');
 const prepare=async()=>{if(busy)return;setBusy(true);setError('');try{
  const draft=await authFetch(`/iesire/${invoiceId}/storno-draft`);
  nav('/iesire/new?from_storno=1',{state:{stornoInvoice:draft}});
 }catch(e){setError(e.message);}finally{setBusy(false);}};
 return <><Button type="button" variant="outline-warning" disabled={disabled||busy} onClick={prepare}>{busy?'Se pregătește…':'Storno'}</Button>{error&&<Alert variant="danger">{error}</Alert>}</>;
}
